module.exports = __webpack_public_path__ + "img/user_avatar_default.32119e23.png";